import React from 'react';

import { useSelector } from 'react-redux';
import { selectHeroWelcomeTextsHtml } from '@/store/cms/welcome-texts/selectors';
import { selectHeroBackgrounds } from '@/store/cms/hero-backgrounds/selectors';
import { cdnImage, CDNImageProps } from '@/utils/image-utils';
import LinearGradient from '@/components/shared/gradient/LinearGradient';
import CmsStyledContent from '@/components/shared/CmsStyledContent';
import classNames from 'classnames';
import { MODALS } from '@/features/modal/types';
import { useIntl } from 'react-intl';
import { useModal } from '@/features/modal/useModal';

const desktopProps: CDNImageProps = { width: '760', height: '300', fit: 'crop' };

const WelcomeOfferBanner = () => {
  const intl = useIntl();
  const { openModal } = useModal();
  const welcomeText = useSelector(selectHeroWelcomeTextsHtml);
  const heroBackgrounds = useSelector(selectHeroBackgrounds);
  const bannerBackground = heroBackgrounds.unauthenticated;

  return (
    <div
      className="relative flex flex-col items-center justify-center py-4 rounded-xl overflow-hidden mb-6
      flex flex-col items-center"
    >
      <div
        className="absolute left-0 right-0 bottom-0 top-0 after:absolute after:right-0 after:left-0 after:bottom-0
        after:top-0 z-0"
      >
        <LinearGradient
          from="rgba(0, 0, 0, 0.3)"
          to="rgba(0, 0, 0, 0.75)"
          direction="bottom"
          transitionPoint="60%"
        />
        <picture className="w-full h-full block object-cover object-center">
          <img
            className="object-cover object-center w-full h-full"
            src={cdnImage(bannerBackground.desktop ?? 'luckydays-beach.jpg', desktopProps)}
            alt="Welcome offer illustration"
          />
        </picture>
      </div>
      <div className="z-1 relative sm:text-xl max-w-[85%] sm:max-w-[75%] h-fit">
        <CmsStyledContent
          text={welcomeText}
          stylesOverride={classNames(
            '[&_p]:text-xs [&_p]:sm:text-sm flex flex-col items-center justify-center gap-2.5',
            '[&_h1]:leading-[1.2] [&_h1]:text-xl [&_h1]:sm:text-2xl [&_h1]:md:text-3xl',
            '[&_h2]:leading-[1.2] [&_h2]:text-base [&_h2]:sm:text-lg [&_h2]:md:text-xl',
          )}
        />
        <button
          type="button"
          onClick={() => openModal(MODALS.BONUS_TERMS_AND_CONDITIONS)}
          className="bold italic underline text-white leading-snug text-xs sm:text-sm"
        >
          {intl.formatMessage({
            id: 'authentication.registration.canada.description.terms-and-conditions',
          })}
        </button>
      </div>
    </div>
  );
};

export default WelcomeOfferBanner;
